// mt-volume-tiers (spec/port-pdp.md §2.4). Tutarları Liquid biçimler (kart data-*); burada yalnız seçim uygulanır,
// seçilen kartın değeri ATC / fiyat / sticky çubuğa yazılır ve sepet sonrası indirim bekçisi çalışır.
// QA tur 1 (pdp-1, pdp-5): kart tıklaması tek görevde ve zorlanmış yerleşim olmadan boyanır; sunucu yanıtı kartları
// yeniden KURMAZ (düğümler, odak ve "+N hediye" yerinde kalır), yalnız değişen öznitelik/metin güncellenir.
import { StandardEvents } from '@shopify/events';

/** Birim indirim (kuruş): floor(P × pct / 100). Liquid'deki `times | divided_by` ile aynı. */
export const unitDiscount = (cents, pct) => Math.floor((cents * pct) / 100);

/** n adet için geçerli kademe yüzdesi; tiers = [[min, pct], …] artan. */
export const tierPct = (n, tiers) => tiers.reduce((p, [min, pct]) => (n >= min ? pct : p), 0);

/** /cart.js içinde bu ürünün satırlarına beklenen kademe payı uygulanmış mı (eksikse ok=false; ±1 kuruş/adet). */
export function cartCheck(cart, productId, tiers, subExcluded) {
  const lines = cart.items.filter((l) => l.product_id === productId && !(subExcluded && l.selling_plan_allocation));
  let qty = 0, expected = 0, got = 0;
  for (const l of lines) qty += l.quantity;
  const pct = tierPct(qty, tiers);
  for (const l of lines) {
    expected += unitDiscount(l.original_price, pct) * l.quantity;
    for (const a of l.line_level_discount_allocations || []) got += a.amount;
  }
  return { ok: got >= expected - qty, qty, pct, expected, got };
}

const motion = globalThis.matchMedia && matchMedia('(prefers-reduced-motion: reduce)');
// Kart içinde sunucudan yerinde güncellenen parçalar ([data-gift] ayrı: hediye haritası yazar).
const PARTS = ['.mt-vt__badge', '.mt-vt__title', '.mt-vt__price', '.mt-vt__sub', '.mt-vt__x:not([data-gift])'];

if (globalThis.customElements && !customElements.get('mt-volume-tiers')) {
  customElements.define(
    'mt-volume-tiers',
    class extends HTMLElement {
      connectedCallback() {
        this.sec = this.closest('.shopify-section') || document.body;
        this.ac = new AbortController();
        const o = { signal: this.ac.signal };
        this.addEventListener('change', this.onPick, o);
        this.sec.addEventListener(StandardEvents.productSelect, this.onSelect, o);
        this.sec.addEventListener('mt:purchase-option-change', this.onPlan, o);
        if (this.dataset.mode === 'quantity') document.addEventListener('mt:cart:updated', this.onCart, o);
        this.render();
      }

      disconnectedCallback() {
        this.ac.abort();
        cancelAnimationFrame(this.raf);
      }

      get input() {
        return this.querySelector('.mt-vt__input:checked');
      }

      get picker() {
        return this.sec.querySelector(`variant-picker[data-product-id="${this.dataset.productId}"]`);
      }

      // Sıra: Horizon radyosu işaretlenir → form `id` kartın varyantına yazılır (ATC yanıtı beklemeden doğru varyantı
      // gönderir) → bizim yazımlar (okuma yok) → en son Horizon `change` (sunucu isteği + hediye özeti).
      onPick = (e) => {
        const i = e.target;
        if (!i.classList || !i.classList.contains('mt-vt__input')) return;
        e.stopPropagation();
        let n = null;
        if (this.dataset.mode === 'package') {
          const p = this.picker;
          n = p && p.querySelector(`input[data-option-value-id="${i.value}"]`);
          if (n && n.checked) n = null;
          if (n) n.checked = true;
          const v = i.dataset.variantId;
          if (v) this.sec.querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"]').forEach((f) => (f.value = v));
        }
        this.render(true);
        if (n) n.dispatchEvent(new Event('change', { bubbles: true }));
      };

      // Varyant değişince (paket kartı, Beden/Renk) sunucu yanıtındaki kart verisi yerinde uygulanır; düğüm değişmez.
      // render() bir sonraki karede (boyamadan önce): Horizon fiyat/ATC/sticky morph'ları aynı görevde bitmiş olur,
      // adet modunda tekil fiyatın arada boyanması da önlenir.
      onSelect = (e) => {
        if (!e.promise) return;
        e.promise
          .then(({ detail }) => {
            const fresh = detail && detail.html && detail.html.querySelector(`mt-volume-tiers[data-block-id="${this.dataset.blockId}"]`);
            if (fresh) this.patch(fresh);
            cancelAnimationFrame(this.raf);
            this.raf = requestAnimationFrame(() => this.render());
          })
          .catch(() => {});
      };

      patch(fresh) {
        const q = this.dataset.mode === 'quantity';
        const now = [...this.querySelectorAll('.mt-vt__input')];
        const nu = [...fresh.querySelectorAll('.mt-vt__input')];
        if (now.length !== nu.length || now.some((i, k) => i.value !== nu[k].value)) {
          // Kart kümesi değişti (başka ürün / kademe): eski yol, tam yenileme.
          const n = q && this.input && this.input.value;
          this.replaceChildren(...document.importNode(fresh, true).childNodes);
          const r = n && this.querySelector(`.mt-vt__input[value="${n}"]`);
          if (r) r.checked = true;
          return;
        }
        const srv = [];
        now.forEach((i, k) => {
          const f = nu[k];
          for (const a of f.attributes) if (a.name.startsWith('data-') && i.getAttribute(a.name) !== a.value) i.setAttribute(a.name, a.value);
          for (const a of [...i.attributes]) if (a.name.startsWith('data-') && !f.hasAttribute(a.name)) i.removeAttribute(a.name);
          // Paket: seçim sunucunun seçili varyantını izler (zaten aynıysa dokunulmaz). Adet: kullanıcının kademesi kalır.
          if (!q && f.hasAttribute('checked') && !i.checked) i.checked = true;
          const card = i.parentNode;
          const fc = f.parentNode;
          for (const sel of PARTS) {
            const a = card.querySelector(sel);
            const b = fc.querySelector(sel);
            if (a && b) {
              if (a.innerHTML !== b.innerHTML) a.innerHTML = b.innerHTML;
            } else if (a) a.remove();
            else if (b) card.append(document.importNode(b, true));
          }
          const g = fc.querySelector('[data-gift]');
          srv[k] = g ? g.innerHTML : null;
        });
        if (!q) this.gifts(srv);
      }

      onPlan = (e) => {
        this.plan = !!(e.detail && e.detail.plan);
        this.toggleAttribute('data-sub', this.plan && this.dataset.subExcluded === 'true');
        this.render();
      };

      onCart = () => {
        if (this.dataset.scope !== 'product') return;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          fetch(root + 'cart.js')
            .then((r) => r.json())
            .then((cart) => {
              const r = cartCheck(cart, +this.dataset.productId, JSON.parse(this.dataset.tiers || '[]'), this.dataset.subExcluded === 'true');
              if (!r.ok) {
                const detail = { offerId: this.dataset.offer, expected: r.expected, got: r.got };
                console.warn('[mt-volume-tiers] indirim uygulanmadı', detail);
                document.dispatchEvent(new CustomEvent('mt:volume:mismatch', { detail }));
              }
              if (this.hasAttribute('data-mt-mismatch') === r.ok) {
                this.toggleAttribute('data-mt-mismatch', !r.ok);
                this.render();
              }
            })
            .catch(() => {});
        }, 300);
      };

      render(user) {
        const i = this.input;
        if (!i) return;
        const d = i.dataset;
        const q = this.dataset.mode === 'quantity';
        const plain = q && (this.hasAttribute('data-sub') || this.hasAttribute('data-mt-mismatch'));
        const total = plain ? d.ptotal : d.total;
        if (this.hasAttribute('data-plain') !== plain) this.toggleAttribute('data-plain', plain);
        if (q) {
          this.qty(i.value);
          const h = this.querySelector('[data-hint]');
          const t = this.hasAttribute('data-sub') ? this.dataset.hintSub : d.hint;
          if (h && h.textContent !== t) h.textContent = t;
        } else this.gifts();
        if (this.hasAttribute('data-sync') && !this.plan && total) this.sync(total, plain ? d.pcents : d.cents, plain ? d.pper : d.per, d.label, q, user);
        // Ekran okuyucu duyurusu boyamadan sonra (tıklama görevini uzatmasın).
        if (user) {
          const s = this.querySelector('[role="status"]');
          const t = d.label + ', ' + total;
          if (s) requestAnimationFrame(() => setTimeout(() => (s.textContent = t), 0));
        }
      }

      // Adet: Horizon adet seçicisi (görsel olarak gizli) ya da yoksa forma gizli quantity alanı.
      qty(n) {
        const sel = this.sec.querySelector('product-form-component quantity-selector-component');
        if (sel) {
          customElements.whenDefined(sel.localName).then(() => {
            if (sel.getValue() !== n) {
              sel.setValue(n);
              sel.onQuantityChange();
            }
          });
          return;
        }
        const f = this.sec.querySelector('form[data-type="add-to-cart-form"]');
        if (!f) return;
        let h = f.querySelector('input[name="quantity"]');
        if (!h) f.append((h = Object.assign(document.createElement('input'), { type: 'hidden', name: 'quantity' })));
        if (h.value !== n) h.value = n;
      }

      // Paket kartlarında "+N hediye" (mt-gift-unlock haritası). srv: sunucu yanıtındaki [data-gift] içerikleri;
      // hediyesi olmayan kartta o içerik (Tükendi / Dene) yazılır. Aynı metin yeniden yazılmaz (DOM değişmez).
      gifts(srv) {
        let map = null;
        try {
          map = JSON.parse(this.sec.querySelector('[data-mt-gift-map]').dataset.mtGiftMap);
        } catch (_) {}
        if (!map && !srv) return;
        this.querySelectorAll('.mt-vt__input').forEach((i, k) => {
          const x = i.parentNode.querySelector('[data-gift]');
          if (!x) return;
          const n = map ? +map[i.dataset.value] || 0 : 0;
          if (n) {
            const t = this.dataset.giftsTpl.replace('[n]', n);
            if (x.textContent !== t) x.textContent = t;
            if (!x.classList.contains('mt-vt__x--gift')) x.classList.add('mt-vt__x--gift');
          } else if (srv && srv[k] != null && x.innerHTML !== srv[k]) {
            x.innerHTML = srv[k];
            x.classList.remove('mt-vt__x--gift');
          }
        });
      }

      // Bütün yazımlar tek blokta, yerleşim okuması yok. Parlama Web Animations ile (yerleşim zorlamaz);
      // reduced-motion'da yok.
      sync(total, cents, per, label, q, user) {
        const s = this.sec;
        const flash = user && !(motion && motion.matches) ? [] : null;
        const set = (el, t) => {
          if (!el || !t || el.textContent === t) return;
          el.textContent = t;
          if (flash) flash.push(el);
        };
        const atc = s.querySelectorAll('[data-mt-price]');
        atc.forEach((el) => {
          set(el, total);
          if (el.dataset.cents !== String(cents)) el.dataset.cents = cents;
        });
        if (!atc.length) {
          // Bugünkü add-to-cart MT-PATCH'i: "fiyat · etiket" tek metin düğümü.
          const w = s.querySelector('[data-mt-atc-label]');
          const b = w && w.querySelector('[ref="addToCartButton"]');
          const node = b && !b.disabled && [...b.childNodes].find((c) => c.nodeType === 3 && c.textContent.trim());
          if (node) node.textContent = total + ' · ' + w.dataset.mtAtcLabel;
        }
        const main = s.querySelector('product-price [ref="priceContainer"]');
        if (main && !main.querySelector('.compare-at-price')) set(main.querySelector('.price bdi'), total);
        s.querySelectorAll('[data-mt-unit]').forEach((el) => set(el, per));
        const sp = s.querySelector('.sticky-add-to-cart__price [ref="priceContainer"]');
        if (sp && !sp.hasAttribute('data-mt-plan')) set(sp.querySelector('.price bdi'), total);
        const v = s.querySelector('.sticky-add-to-cart__variant');
        if (v && q) {
          const base = v.dataset.mtVt === v.textContent ? v.dataset.mtBase : v.textContent.trim();
          const t = base ? base + ' · ' + label : label;
          if (v.dataset.mtBase !== base) v.dataset.mtBase = base;
          if (v.textContent !== t) v.textContent = t;
          if (v.dataset.mtVt !== t) v.dataset.mtVt = t;
          if (v.style.display) v.style.display = '';
        } else if (v && user) {
          // Paket: sticky'deki varyant adı (Horizon'un variant.title'ı = seçili değerler " / " ile) hemen yazılır;
          // sunucu morph'u aynı metni getirir.
          const p = this.picker;
          const t = p && [...p.querySelectorAll('fieldset input:checked, select')].map((x) => x.value).join(' / ');
          if (t && v.textContent.trim() !== t) v.textContent = t;
        }
        if (flash) for (const el of flash) if (el.animate) el.animate([{ opacity: 0.35 }, { opacity: 1 }], { duration: 220, easing: 'ease' });
      }
    }
  );
}
